// extracted by mini-css-extract-plugin
export var Consent = "index-module--Consent--9e272";
export var ConsentSection = "index-module--ConsentSection--58bd8";
export var SmallMessage = "index-module--SmallMessage--f39fe";
export var Title = "index-module--Title--29165";